import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import { siteBrand, siteStats } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20warm%20background%20texture%20with%20deep%20espresso%20and%20brick%20red%20gradient%2C%20a%20soft%20golden%20light%20beam%20crossing%20the%20frame%2C%20layered%20paper%20cutout%20geometric%20shapes%2C%20subtle%20halftone%20grain%2C%20low%20contrast%2C%20cinematic%20depth%2C%20no%20people&width=1600&height=900&seq=shenguashe-hero-01&orientation=landscape"
          alt="深瓜社编辑部抽象暖色背景"
          title="热门大瓜深度复盘 - 深瓜社"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50"></div>
      </div>

      <Container className="relative z-10 flex min-h-[520px] flex-col justify-center py-16 md:min-h-[640px] md:py-20">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
            <i className="ri-pulse-line"></i>
            {siteBrand.updateNote}
          </span>
          <h1 className="mt-6 font-heading text-4xl font-bold leading-tight tracking-tight text-background-50 md:text-6xl">
            看懂高潮之前的
            <br />
            所有伏笔
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            深瓜社专注热门大瓜深扒：把公开可查的痕迹按时间排开，附上未删减原稿片段，
            复盘事件的来龙去脉。不传谣、不站队，只把完整时间线理清楚。
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/topics"
              className="inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 sm:w-auto"
            >
              <i className="ri-flashlight-line"></i>
              进入瓜田
            </Link>
            <Link
              to="/timeline"
              className="inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-history-line"></i>
              查看全网时间线
            </Link>
          </div>
        </div>

        <div className="mt-14 grid w-full grid-cols-2 gap-6 border-t border-background-50/20 pt-8 lg:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label}>
              <p className="font-heading text-3xl font-bold text-accent-300 md:text-4xl">{stat.value}</p>
              <p className="mt-1 text-xs tracking-wide text-background-200">{stat.label}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}